import { getAmplitudeInstance } from '../amplitudeHelpers';
import ExploreMapTrailCardListActionTaken from '../enums/ExploreMapTrailCardListActionTaken';
import ExploreMapTrailCardSortingActionTaken from '../enums/ExploreMapTrailCardSortingActionTaken';

type logExploreTrailCardListActionTakenParams = {
  action_taken?: ExploreMapTrailCardListActionTaken;
  sorting_action?: ExploreMapTrailCardSortingActionTaken;
  trail_id?: number;
};

/**
 * User interacts with a trail card on the explore map on web. 'Hovered' action not included to reduce noise.
 * @param params - Attributes to log with the amplitude event
 * @param params.action_taken - The action a user took on the trail card.
 * @param params.sorting_action - The sorting option a user selected. Only applies when a user took the 'sorted' action in action_taken.
 * @param params.trail_id - The id of the trail
 */
const logExploreTrailCardListActionTaken = (
  { action_taken, sorting_action, trail_id }: logExploreTrailCardListActionTakenParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'explore trail card list action taken',
    { 'action taken': action_taken, 'sorting action': sorting_action, 'trail id': trail_id },
    callback
  );
};

export default logExploreTrailCardListActionTaken;
